import Vue from 'vue'
import Router from 'vue-router'
import SubmissionList from '@/components/SubmissionList'
import ReviewList from '@/components/ReviewList'
import SnippetList from '@/components/SnippetList'
import SettingList from '@/components/SettingList'
import MessageList from '@/components/MessageList'
import QuestionList from '@/components/QuestionList'
import UserList from '@/components/UserList'
import CollegeList from '@/components/CollegeList'
import SignUpList from '@/components/SignUpList'
import SurveyList from '@/components/SurveyList'
import OperationsPanel from '@/components/OperationsPanel'
import MailLog from '@/components/MailLog'
import UploadList from '@/components/UploadList'
import MailingList from '@/components/MailingList'
import Home from '@/components/Home'

Vue.use(Router);

const MainRouter = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: false,
        isAdmin: false
      }
    },
    {
      path: '/submissions/:filter?/:id?/:itemId?/:mode?',
      name: 'submissions',
      component: SubmissionList,
      meta: {
        requiresAuth: true,
        isAdmin: true
      }
    },
    {
      path: '/review/:filter?/:seq?',
      name: 'review',
      component: ReviewList,
      meta: {
        requiresAuth: true,
        isAdmin: false
      }
    },
    {
      path: '/snippets/:section?/:id?',
      name: 'snippets',
      component: SnippetList,
      meta: {
        requiresAuth: true,
        isAdmin: true
      }
    },
    {
      path: '/settings/:id?',
      name: 'settings',
      component: SettingList,
      meta: {
        requiresAuth: true,
        isAdmin: true
      }
    },
    {
      path: '/messages/:id?',
      name: 'messages',
      component: MessageList,
      meta: {
        requiresAuth: true,
        isAdmin: true
      }
    },
    {
      path: '/questions/:id?',
      name: 'questions',
      component: QuestionList,
      meta: {
        requiresAuth: true,
        isAdmin: true
      }
    },
    {
      path: '/colleges/:id?',
      name: 'colleges',
      component: CollegeList,
      meta: {
        requiresAuth: true,
        isAdmin: true
      }
    },
    {
      path: '/operations',
      name: 'operations',
      component: OperationsPanel,
      meta: {
        requiresAuth: true,
        isAdmin: true
      }
    },
    {
      path: '/responses/:id?',
      name: 'responses',
      component: SurveyList,
      meta: {
        requiresAuth: true,
        isAdmin: true
      }
    },
    {
      path: '/mail-logs',
      name: 'maillog',
      component: MailLog,
      meta: {
        requiresAuth: true,
        isAdmin: true
      }
    },
    {
      path: '/users/:id?',
      name: 'users',
      component: UserList,
      meta: {
        requiresAuth: true,
        isAdmin: true
      }
    },
    {
      path: '/signup/:id?',
      name: 'signup',
      component: SignUpList,
      meta: {
        requiresAuth: true,
        isAdmin: true
      }
    },
    {
      path: '/mail-list',
      name: 'maillist',
      component: MailingList,
      meta: {
        requiresAuth: true,
        isAdmin: true
      }
    },
    {
      path: '/uploads/:name?',
      name: 'upload',
      component: UploadList,
      meta: {
        requiresAuth: true,
        isAdmin: true
      }
    },
  ],
});

MainRouter.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const user = Vue.ls.get('user');
    let role = 'none';
    let mayAccess;
    if (user instanceof Object) {
      if (user.valid) {
        if (user.role) {
          role = user.role;
        }
      }
    }
    if (to.meta.isAdmin) {
      mayAccess = role === 'admin';
    } else {
      mayAccess = role !== 'none';
    }
    if (mayAccess) {
      next()
    } else {
      next(
        { name: 'home' }
      );
    }
  } else {
    next()
  }
})

export default MainRouter;
